import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, BarChart3, Check, FileText, Headphones, Lock, MessageCircle, Phone, ShieldCheck, Video } from 'lucide-react';
import { SiteHeader } from '../components/AuthShell';
import PlanCards, { openContact } from '../components/PlanCards';
import { useTenant } from '../context/TenantContext';
import '../components/AuthShell.css';
import './Subscription.css';

const PLATFORM = ['Voice Calls', 'Video Meetings', 'AI Receptionist', 'WhatsApp Business', 'Contact Center', 'Call Analytics'];
const WHY = [
  ['Reliable & Secure', 'Enterprise-grade security for your business data.', Lock],
  ['Scale as You Grow', 'Flexible plans for teams of any size.', BarChart3],
  ['Dedicated Support', 'From setup to growth, we\'re always here for you.', Headphones],
  ['Transparent Billing', 'GST invoices and no hidden charges.', FileText],
  ['Enterprise Security', 'Your data is our priority.', ShieldCheck],
];

/** Plan choice for a company that isn't on a paid plan yet: where a new company lands after sign-up. */
export default function Subscription() {
  const navigate = useNavigate();
  const { tenant, onboarding } = useTenant();
  const canSkip = !onboarding || onboarding === 'approved'; // a new company chooses and pays first

  return (
    <div className="tcx-auth">
      <SiteHeader>
        {canSkip && <button type="button" className="tcx-back" onClick={() => navigate('/')}>Skip for now<ArrowRight size={14} /></button>}
      </SiteHeader>
      <main className="tcx-plans-page">
        <aside className="tcx-plans-side tcx-plans-platform">
          <h2>All-in-One Business Calling <em>Platform</em></h2>
          <p>Connect with your customers anytime, anywhere.</p>
          <ul>{PLATFORM.map((f) => <li key={f}><span><Check size={14} strokeWidth={3} /></span>{f}</li>)}</ul>
          <div className="tcx-plans-globe" aria-hidden="true">
            <div className="glow-orb" />
            <div className="orbit orbit-one" />
            <div className="globe"><div className="globe-grid" /><div className="continent c1" /><div className="continent c2" /><div className="continent c3" /><div className="globe-shine" /></div>
            <span className="tcx-plans-app call"><Phone size={22} /></span>
            <span className="tcx-plans-app meet"><Video size={22} /></span>
            <span className="tcx-plans-app chat"><MessageCircle size={22} /></span>
          </div>
        </aside>

        <section className="tcx-plans-center">
          <div className="tcx-page-heading">
            <span className="tcx-eyebrow"><i />CHOOSE YOUR PLAN</span>
            <h1>Choose a plan for your business</h1>
            <p>Simple, transparent pricing. Powerful features for every team.</p>
          </div>
          <PlanCards currentTier={tenant.plan} onChoose={(p) => navigate('/payment', { state: { plan: p.code } })}
            onTalk={(p) => openContact(p, tenant.name)} />
          {canSkip && (
            <p className="tcx-page-foot">
              Not ready yet? <button type="button" className="tcx-link-btn" onClick={() => navigate('/')}>Skip for now</button> and choose later from Billing &amp; Plan.
            </p>
          )}
        </section>

        <aside className="tcx-plans-side tcx-plans-why">
          <h2>Why<br /><span>Choose <em>TeleCalX?</em></span></h2>
          <ul>
            {WHY.map(([title, sub, Icon]) => (
              <li key={title}><span><Icon size={20} /></span><div><b>{title}</b><small>{sub}</small></div></li>
            ))}
          </ul>
          <div className="tcx-plans-support" aria-hidden="true">
            <Headphones className="tcx-plans-headset" size={92} strokeWidth={1.6} />
            <div><b>24/7</b>Support</div>
          </div>
        </aside>
      </main>
    </div>
  );
}
